import { SxProps } from "@mui/material";

//TODO: Need to change this any type
export const margeStyle = (target: SxProps, source?: any): SxProps => {
  return [
    ...(Array.isArray(target) ? target : [target]),
    ...(Array.isArray(source) ? source : [source]),
  ];
};
